export default __webpack_public_path__ + "static/Pregnant-Woman-Relaxing-With-Tea-400w-3f89025013a6c677ee994e37a62a7929.jpg";